import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from "@ui/select"

const STATIC_COLLECTION = "STATIC"
const DYNAMIC_COLLECTION = "DYNAMIC"

interface CollectionTypeSelectionProps {
    onChange: (value: boolean) => void
}
export function CollectionTypeSelection({ onChange }: Readonly<CollectionTypeSelectionProps>) {
    const handleChange = (newValue: string) => {
        onChange(newValue === DYNAMIC_COLLECTION)
    }

    return (
        <Select onValueChange={handleChange} defaultValue={STATIC_COLLECTION}>
            <SelectTrigger>
                <SelectValue placeholder="Type" />
            </SelectTrigger>
            <SelectContent>
                <SelectGroup>
                    <SelectItem value={STATIC_COLLECTION} className="hover:cursor-pointer">
                        Collection
                    </SelectItem>
                    <SelectItem value={DYNAMIC_COLLECTION} className="hover:cursor-pointer">
                        Dynamic Collection
                    </SelectItem>
                </SelectGroup>
            </SelectContent>
        </Select>
    )
}
